import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Summary() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>Summary And Rejuvenation Plan</span>
                    </div>
                </section>


                <section class="pad bank-benefits default">

                    <div class="content normal">
                        <div data-lavalamp=""></div>

                        <div class="data margin-top-content">
                            <div class="text">
                                <h3 class="title">Summary Of The Benefits Of Nugenesis</h3>
                                <p class="subtitle">
                                    The limitations of old tech have been surpassed. The NuGenesis
                                    governance system provides for the minting of coins and distribution into
                                    system treasuries to cater for an on-going rate of innovation. That
                                    means:


                                    1. No sluggish inability to upgrade. Instead there is forkless upgrades <br></br><br></br>
                                    2. Treasuries fund investment in exploiting the opportunities of the future
                                    with core devs working on quantum resistance; zero-knowledge proof
                                    integration to protect privacy of data; satellite based off-line
                                    transactions and the virtual reality realm (‘parallel worlds’) where global
                                    interaction by avatars replace the keyboard <br></br><br></br>
                                    3. Treasuries reward all the users in the system for their contribution to
                                    ecosphere, including all users who benefits from an airdrop of 10% of
                                    coins minted each month.

                                </p>
                                <div class="btns">
                                    <a href="document/summary-of-benifits-of-nugenesis.docx" target="_blank" data-patt="track-btn" class="">Download</a>
                                </div>
                            </div>

                        </div>
                        <div class="img-frame img-width40">
                            <img src="images/nugenesisou/pr-illustration-10.png" alt="" />
                        </div>
                    </div>

                </section>

                <section class="pad bank-benefits white">
                    <div class="content normal">
                        <div class="data">
                            <div class="text">
                                <h3 class="title">The Rejuvenation Plan</h3>
                                <p class="subtitle">
                                    The NuGenesis group has, and will continue to create, the most
                                    innovative tech arising from the exclusive emphasis on research and
                                    development from a mix of the most talented people. We have
                                    developed an extensive range of technical innovations; ranging from
                                    the concept pre-commercialisation phase to the full developed and
                                    operational.
                                    <br></br><br></br>

                                    What we offer potential major investors and partners is operational
                                    and advanced technology whose value has not been recognized in
                                    market hype; where the costs and technical development risk has past
                                    and; as result, where the investment is to effect business development
                                    and marketing.
                                    <br></br><br></br>

                                    The technology development has been self-funded by internal
                                    stakeholders.There was no ICO/cap raise and no external debt.

                                </p>
                                <div class="btns">
                                <a href="document/NuGENESIS-REJUVINATION-PLAN-KKNPED-v1.pdf" target="_blank" data-patt="track-btn" class="">Download</a>
                                </div>
                            </div>
                        </div>
                        <div class="img-frame  img-width40">
                            <img src="images/nugenesisou/pr-illustration-21.png" alt="" />
                        </div>
                    </div>

                </section>

            </main>
            <Footer />
        </>
    )
}